exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".datetime-history[data-v-190fcc0a]{display:flex;align-items:center}.datetime[data-v-190fcc0a]{display:flex}.date[data-v-190fcc0a]{width:124px}.time[data-v-190fcc0a]{margin:0 16px;width:76px}", ""]);

